import { Box } from '@/components/Box/Box';
import { TableNewLoaderBody, TableNewLoaderWrapper } from './styles';

export const TableNewLoader = () => {
  return (
    <Box display='flex' gap='12px' flexDirection='column' padding='24px'>
      <TableNewLoaderWrapper>
        <TableNewLoaderBody />
      </TableNewLoaderWrapper>
      <TableNewLoaderWrapper>
        <TableNewLoaderBody />
      </TableNewLoaderWrapper>
      <TableNewLoaderWrapper>
        <TableNewLoaderBody />
      </TableNewLoaderWrapper>
      <TableNewLoaderWrapper>
        <TableNewLoaderBody />
      </TableNewLoaderWrapper>
    </Box>
  );
};
